import type { FaireProductEntity } from "../../entity_types/product";

export const p_8suhw9ddvk: FaireProductEntity = {
  token: "p_8suhw9ddvk",
  type: "product",
  name: "Love You Grandma Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c20ddf7d7ee98161e9c5e8b0bce600ed2aad1e8b8baffe88ec2f7b8753ba52fe.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d322f73ba5509695399b0b5563aeef48f1c542e3bb567bbe696aa9984299a52.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:23.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
